import { render } from "./CreateVariantsModal.vue.js?vue&type=template&id=b4325f3c!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreateVariantsModal.vue?vue&type=template&id=b4325f3c"
import script from "./CreateVariantsModal.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreateVariantsModal.vue?vue&type=script&lang=js"
export * from "./CreateVariantsModal.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreateVariantsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/publication/CreateVariantsModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b4325f3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b4325f3c', __exports__)) {
    api.reload('b4325f3c', __exports__)
  }
  
  module.hot.accept("./CreateVariantsModal.vue.js?vue&type=template&id=b4325f3c!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreateVariantsModal.vue?vue&type=template&id=b4325f3c", () => {
    api.rerender('b4325f3c', render)
  })

}


export default __exports__